import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { getIsPWAInstalled } from 'helpers/getIsPWAInstalled';
import { getFlyingBetslipConfig } from 'helpers/prematch';
import { isCasinoGamePage } from 'utils';

import {
  printMissingConfigError,
  SiteConfigManager,
  useSettings,
  useUserMessages,
} from '@atlas/core';
import { COMPONENT_TYPES, staticRoutes } from '@atlas/routing';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import { PLATFORM_TYPES } from 'common/constants';
import LabelTranslateWithLink from 'common/I18n/Label';

import NavigationBarItem from './NavigationBarItem';

const { MOBILE, MULTIPLATFORM } = PLATFORM_TYPES;

const NewNavigationBar = () => {
  // state of the betslip popup
  const { betIdToEdit } = useLocalBetslip();
  const { quickBet: isQuickBet } = useSettings();
  const { unreadMessagesCount } = useUserMessages();
  const casinoLivePath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO_LIVE);
  const {
    location: { pathname },
  } = useHistory();
  const casinoPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO);

  const betslipNavConfig = useMemo(() => getFlyingBetslipConfig(), []);
  const mobileBottomNavLinks = SiteConfigManager.getConfig('navigation.mobile', []);

  const links = useMemo(
    () =>
      mobileBottomNavLinks
        .filter(el => el.platform_type === MULTIPLATFORM || el.platform_type === MOBILE)
        .slice(0, betslipNavConfig.hasSimple || betslipNavConfig.hasExtended ? 6 : 5)
        .sort((a, b) => a.order_index - b.order_index)
        .map(
          ({
            alt_icon: altIcon,
            icon,
            icon_type: iconType,
            light_icon: lightIcon,
            location,
            name,
            target,
          }) => ({
            altIcon,
            icon,
            iconType,
            lightIcon,
            name,
            path: location,
            target: target === '_blank' ? '_blank' : '',
          }),
        ),
    [betslipNavConfig.hasExtended, betslipNavConfig.hasSimple, mobileBottomNavLinks],
  );

  const navigationClass = cx('navigation new-nav', {
    hidden: isCasinoGamePage(pathname, [casinoPath, casinoLivePath]),
    shadow: isQuickBet || betIdToEdit,
  });

  if (mobileBottomNavLinks.length === 0) {
    printMissingConfigError('navigation.mobile');
  }

  const navBarClass = cx('navigation-tab-bar', { 'is-pwa': getIsPWAInstalled() });

  return (
    <div className={navigationClass}>
      <div className={navBarClass}>
        {links.map(({ altIcon, defaultPath, icon, iconType, lightIcon, name, path, target }) => (
          <LabelTranslateWithLink
            key={path || defaultPath}
            message={name}
            render={t => (
              <NavigationBarItem
                altIcon={altIcon}
                icon={icon}
                iconType={iconType}
                label={t}
                lightIcon={lightIcon}
                link={path || defaultPath}
                target={target}
                withNotification={!!unreadMessagesCount && path === staticRoutes.menu}
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default NewNavigationBar;
